import {NavigationItem} from './navigation-item';
import {Input} from '@angular/core';
import {BaseActions} from '../shared/base-actions';

export abstract class SelectableNavigationItem extends BaseActions implements NavigationItem {

  @Input()
  active: boolean;
  @Input()
  name: string;
  @Input()
  ownerComponent: string;
  @Input()
  x: number;
  @Input()
  y: number;

  protected constructor() {
    super();
    this.y = 0;
    this.x = 0;
  }

  activate(active: boolean): void {
    this.active = active;
  }

  canNavigateToDirection(keyCode: number): boolean {
    return true;
  }

  isSelectable(): boolean {
    return true;
  }

  isSubscribed(): boolean {
    return false;
  }

  abstract onBack(): void;

  abstract onEnter(): void;

}
